import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

// Sends page views and events to Google Analytics and mirrors site actions
// to the internal activity dashboard. If no Measurement ID is set, the GA calls
// are no-ops and nothing breaks.
@Injectable({ providedIn: 'root' })
export class AnalyticsService {
  constructor(private http: HttpClient) {}

  pageView(path: string): void {
    const g = (window as unknown as { gtag?: (...a: unknown[]) => void }).gtag;
    if (g) g('event', 'page_view', { page_path: path });
  }

  ga(name: string, slug?: string): void {
    const g = (window as unknown as { gtag?: (...a: unknown[]) => void }).gtag;
    if (g) g('event', name, slug ? { slug } : {});
  }

  private activity(type: string, slug = ''): void {
    this.http.post('/api/activity', { type, slug }).subscribe({ error: () => {} });
  }

  // Fire a site action to both GA and the internal dashboard.
  track(name: string, slug = ''): void {
    this.ga(name, slug || undefined);
    this.activity(name, slug);
  }
}
